export default {
    INIT: 'INIT',
    SET_ESTIMATE_LOADING: 'SET_ESTIMATE_LOADING',
    SET_ESTIMATE_LOADED: 'SET_ESTIMATE_LOADED',
    SET_ESTIMATES: 'SET_ESTIMATES',
};
